import React from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import ImageFill from '@ad-scripts/presentation/components/common/icons/fill/image-fill';
import InsetContainer from '@ad-scripts/presentation/components/common/containers/inset_container';
import FieldContainer from 'src/presentation/components/forms/FieldContainer';
import SmsStrokeIcon from '@ad-scripts/presentation/components/common/icons/stroke/sms-stroke';
import VoiceFillIcon from '@ad-scripts/presentation/components/common/icons/fill/voice-fill';
import { H3 } from '@ad-scripts/presentation/components/common/headers';

const EmptyStateDescription = {
  AREA_CODE: 'Confirm that the 3-digit area code you entered is valid',
  CONTAINS: 'Check for typos or try a different search (e.g. “******GLAD”)',
  LOCALITY: 'Check for typos or try a different search',
};

export function EmptyStateView({ searchText, dataAid = 'phone-numbers', filterType }) {
  const description = EmptyStateDescription[filterType as string];

  return (
    <EmptyStateWrapper data-aid={`${dataAid}-emptyMessage`}>
      <H3>{`No results found for "${searchText}"`}</H3>
      <P>{description}</P>
    </EmptyStateWrapper>
  );
}

export function CapabilitiesIcons({ capabilities }) {
  const iconsTemplates = {
    sms: <SmsStrokeIcon />,
    mms: <ImageFill />,
    voice: <VoiceFillIcon />,
  };
  return (
    <IconsWrap>
      {capabilities.map(capability => (
        <IconWrap key={capability}>{iconsTemplates[capability.toLowerCase()]}</IconWrap>
      ))}
    </IconsWrap>
  );
}

export const getCityWithRegion = ({ locality, region }) => {
  const cityList = [locality, region].filter(item => !isEmpty(item));
  if (isEmpty(cityList)) {
    return 'N/A (toll-free)';
  }
  return cityList.join(', ');
};

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 24px;

  > ${FieldContainer} {
    margin: 0 12px;
  }
  > ${FieldContainer}:first-child {
    margin-left: 0;
  }
  > ${FieldContainer}:last-child {
    margin-right: 0;
  }
`;

const EmptyStateWrapper = styled(InsetContainer).attrs({ inset: 'large' })`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 200px;
  justify-content: center;
`;

const P = styled.p`
  margin: 0;
`;

const IconsWrap = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrap = styled.div`
  width: ${({ theme }) => theme.spacing.large};
  margin-right: ${({ theme }) => theme.spacing.medium};
  fill: ${({ theme }) => theme.colors.gray700};
`;
